<template>
  <div class="attachments-list card">
    <div class="card-header d-flex justify-content-between">
      <h5 class="m-0">{{ $t('Logo') }}</h5>
    </div>
    <div class="card-body">
      <div>
        <file-uploader :show-preview="false" @onItemsAdd="onLogoChange" @onItemRemove="onItemRemove"
                       :with-tooltip="false" :items-prop="files"
                       :text="$t('Drag your logo here')" :button-text="$t('Select Logo')"
                       :hint-text="false" :multiple="false" :uploading-progress="uploadingProgress"
                       :uploading-progress-value="uploadingProgressValue" :accept="fileUploaderAccept"
                       ref="fileUploader"/>
      </div>
    </div>
  </div>
</template>

<script>
  import FileUploader from "@/core/components/file-uploader/FileUploader";
  import {createNamespacedHelpers} from "vuex";

  const {mapState, mapActions} = createNamespacedHelpers('customer/customerView');
  const {mapState: mapStateGlobal} = createNamespacedHelpers('global');

  export default {
    name: "CustomerLogoUploader",
    components: {FileUploader},
    data() {
      return {
        uploadingProgressValue: 0,
        uploadingProgress: false,
        files: []
      }
    },
    computed: {
      ...mapState({
        customer: state => state.customer,
      }),
      ...mapStateGlobal(['imageFileFormats', 'attachmentMaxFileSize']),
      fileUploaderAccept() {
        return [{formats: this.imageFileFormats, size: this.attachmentMaxFileSize}]
      },
    },
    created() {
      this.files = this.customer && this.customer.logo ? [this.customer.logo] : []
    },

    methods: {
      ...mapActions(['createCustomerLogo', 'deleteCustomerLogo']),
      async onItemRemove() {
        let response = await this.deleteCustomerLogo({id: this.customer.uuid});
        if (response.success) {
          this.clearData()
          this.customer.logo_uuid = null;
          this.customer.logo = null;
          this.$toast('success', this.$i18n.t('Logo was deleted successfully'));
        } else {
          if (response.body.non_field_errors) {
            this.$errorDialog(response.body.non_field_errors[0]);
          }
        }
      },
      async onLogoChange() {
        if (this.files.length > 1) {
          this.clearData()
          this.$errorDialog(this.$i18n.t('Only single file is allowed'), this.$i18n.t('Customer Logo'));
        } else if(this.files.length === 1){
          this.uploadingProgress = true;
          let formData = new FormData();
          formData.append('file', this.files[0].file);
          let response = await this.createCustomerLogo({
            formData, id: this.customer.uuid,
            onUploadProgress: (progressEvent) => {
              this.uploadingProgressValue = parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100));
            }
          });
          if (response.success) {
            this.customer.logo_uuid = response.body.logo_uuid;
            this.customer.logo = response.body.logo;
            this.$toast('success', this.$i18n.t('Logo was uploaded successfully'));
          } else if(response.body.file) {
            this.clearData()
            this.$errorDialog(response.body.file);
          }
          else if (response.body.non_field_errors) {
            this.$errorDialog(response.body.non_field_errors[0])
          }
          this.uploadingProgress = false;
          this.uploadingProgressValue = 0;
        }
      },
      clearData() {
        this.$refs.fileUploader.clearInput();
        this.files = [];
      }
    },
  }
</script>

<style scoped>

</style>